import { BulkCalendarControlDateRange } from "../BulkCalendarControl.types";

export function getDateRangeName(dateRange: BulkCalendarControlDateRange) {
  switch (dateRange) {
    case BulkCalendarControlDateRange.Annual:
      return "Annual";
    case BulkCalendarControlDateRange.Quarter:
      return "Quarter";
    case BulkCalendarControlDateRange.Month:
      return "Month";
    case BulkCalendarControlDateRange.Week:
      return "Week";
    case BulkCalendarControlDateRange.Day:
      return "Day";
    default:
      throw new Error("No name given for date range");
  }
}
